module.exports = __webpack_public_path__ + "img/demo-services-officine.57fac233.jpg";